import React from 'react';
import { Dialog, Pane, Button, Tooltip, TrashIcon, Text } from 'evergreen-ui';

export function DeleteDialog(props) {
    const [isShown, setIsShown] = React.useState(false);

    return (
        <>
            <Dialog
                isShown={isShown}
                title="Warning this can not be undone"
                intent="danger"
                onCloseComplete={() => setIsShown(false)}
                confirmLabel="Delete"
                shouldCloseOnOverlayClick={false}
                onConfirm={() => { props.onDelete(); setIsShown(false); }}
            >
                <Text>Are you sure you want to delete this {props.named}?</Text>
            </Dialog>
            {props.button &&
            <Button gap="10px" appearance='primary' intent='danger' onClick={() => setIsShown(true)}>
                <TrashIcon cursor={"pointer"} color={props.color ? props.color : "darkred"} >{props.children}</TrashIcon> Delete Selected
            </Button>
            }
            {!props.button && 
             <TrashIcon onClick={() => setIsShown(true)} cursor={"pointer"} color={props.color ? props.color : "darkred"} >{props.children}</TrashIcon>
            }

        </>
    );
}
